module.exports = __webpack_public_path__ + "static/media/numberMatka.e9371bf8.png";